import {useCallback} from "react";
import {FilterTypes} from "../constans/filter";
import {ParamTypes} from "../constans/paramTypes";

export function useSQLTableFilterType() {
    return useCallback((type) => {
        if (type === null) return FilterTypes.NUMBER;
        switch (type) {
            case ParamTypes.AGE:
            case ParamTypes.AMOUNT:
            case ParamTypes.DAYS:
            case ParamTypes.INDEX:
            case ParamTypes.WEIGHT:
                return FilterTypes.NUMBER;
            case ParamTypes.TIME:
                return FilterTypes.DATE;
            case ParamTypes.ANIMAL:
                return FilterTypes.STRING;
            default:
                return FilterTypes.ASYNC_DICTIONARY;
        }
    }, []);
}
